import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Mail, Send, Paperclip } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { EmailEnvoyeDialog } from './EmailEnvoyeDialog';
import { EnvoiEmailCandidatDialog } from './EnvoiEmailCandidatDialog';

export const EmailsEnvoyesCard = ({ candidat }) => {
  const [mails, setMails] = useState([]);
  const [ouvert, setOuvert] = useState(null);
  const [ecrire, setEcrire] = useState(false);

  const charger = useCallback(() => {
    if (candidat?.email) axios.get('/emails-envoyes', { params: { email: candidat.email } }).then((r) => setMails(r.data)).catch(() => {});
  }, [candidat?.email]);
  useEffect(() => { charger(); }, [charger]);

  return (
    <Card className="border-2 border-sky-200 bg-sky-50/30" data-testid="emails-envoyes-card">
      <CardHeader>
        <CardTitle className="flex items-center justify-between text-lg">
          <span className="flex items-center gap-2"><Mail className="h-5 w-5 text-sky-600" /> E-mails envoyés</span>
          <Button size="sm" onClick={() => setEcrire(true)} disabled={!candidat?.email} className="bg-[#8DC63F] hover:bg-[#7AB62F]" data-testid="emails-envoyes-ecrire">
            <Send className="h-4 w-4 mr-1.5" /> Écrire
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {mails.length === 0 && <p className="text-sm text-slate-400" data-testid="emails-envoyes-vide">Aucun e-mail conservé pour ce candidat.</p>}
        <ul className="space-y-1.5 max-h-72 overflow-y-auto">
          {mails.map((m) => (
            <li key={m.email_id}>
              <button type="button" onClick={() => setOuvert(m.email_id)} className="w-full text-left rounded-lg bg-white px-3 py-2 border hover:border-sky-300 transition-colors" data-testid={`emails-envoyes-ligne-${m.email_id}`}>
                <p className="text-sm font-medium text-slate-800 truncate">{m.objet}</p>
                <p className="text-xs text-slate-400">
                  {new Date(m.date).toLocaleString('fr-FR')}
                  {m.pieces?.length > 0 && <span className="ml-2"><Paperclip className="inline h-3 w-3" /> {m.pieces.length}</span>}
                </p>
              </button>
            </li>
          ))}
        </ul>
      </CardContent>
      <EmailEnvoyeDialog emailId={ouvert} onClose={() => setOuvert(null)} />
      {ecrire && <EnvoiEmailCandidatDialog open={ecrire} onOpenChange={setEcrire} candidat={candidat} onEnvoye={charger} />}
    </Card>
  );
};
